import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { convertToPlainText } from '@storable/canaveral-rte';
import {
  Form,
} from 'react-bootstrap';
import { compose, clientOnly } from 'utils/react';
import EditableRichText from 'containers/EditableRichText';

class Draft extends React.Component {
  static propTypes = {
    className: PropTypes.string,
    content: PropTypes.shape({
      input: PropTypes.shape({
        onChange: PropTypes.func.isRequired,
        value: PropTypes.object,
      }).isRequired,
      meta: PropTypes.object.isRequired,
    }).isRequired,
    groupClassName: PropTypes.string,
    label: PropTypes.node,
    labelClassName: PropTypes.string,
    snippet: PropTypes.shape({
      input: PropTypes.shape({
        onChange: PropTypes.func.isRequired,
        value: PropTypes.string,
      }).isRequired,
      meta: PropTypes.object.isRequired,
    }).isRequired,
    required: PropTypes.bool,
    site: PropTypes.object.isRequired,
  };

  onChange = (rawContentState) => {
    const { content, snippet } = this.props;

    if (rawContentState === content.input.value) {
      return;
    }

    const plainText = convertToPlainText(rawContentState);
    const plainTextSnippet = `${plainText.split(' ').slice(0, 330).join(' ')} ...`;

    content.input.onChange(rawContentState);
    snippet.input.onChange(plainTextSnippet);
  };

  renderHelp = (error) => {
    if (!error) {
      return null;
    }

    return (
      <Form.Text className="text-danger">
        {error}
      </Form.Text>
    );
  };

  renderLabel = (label, className) => (
    <Form.Label className={className}>
      {label}
    </Form.Label>
  );

  render() {
    const {
      groupClassName,
      content: { input: { name, value }, meta },
      required,
      label,
      labelClassName,
    } = this.props;
    const hasError = meta.error && meta.touched;
    const labelClass = [
      required ? 'required' : null,
      labelClassName,
    ].filter(Boolean).join(' ');

    return (
      <Form.Group validationState={hasError ? 'error' : null} controlId={name} className={groupClassName}>
        {this.renderLabel(label, labelClass)}
        <EditableRichText
          editing
          editorKey="draft-input"
          rawContentState={value}
          onChange={this.onChange}
        />
        {this.renderHelp(hasError ? meta.error : null)}
      </Form.Group>
    );
  }
}

export default compose(
  clientOnly(),
  connect(({ site }) => ({ site }), null),
)(Draft);
